export enum SortingMethod {
  RecentlyViewed = 'Recently viewed',
  RecentlyModified = 'Last modified',
  Alphabetical = 'Alphabetical',
  DateCreated = 'Date created',
  Deleted = 'Deleted'
}
